<template>
  <div :class="$style['pt-lab-product-detail']">
    <pt-page-title title="实验室产品详情"></pt-page-title>
    <div v-if="currentLabProduct">
      <pt-sub-title title="检测项目信息"></pt-sub-title>
      <!-- <pt-form-item label="检测项目编号：" :labelWidth="labelWidth" :lineHeight="lineHeight" :labelColor="labelColor">
        <span>{{currentLabProduct.itemVersion}}</span>
      </pt-form-item> -->
      <pt-form-item label="检测项目名称：" :labelWidth="labelWidth" :lineHeight="lineHeight" :labelColor="labelColor">
        <span>{{currentLabProduct.itemName}}</span>
      </pt-form-item>
      <pt-form-item label="检测依据：" :labelWidth="labelWidth" :lineHeight="lineHeight" :labelColor="labelColor">
        <div :class="$style['package-table-div']" class="page-background" v-if="currentLabProduct.examBasis">
          <table :class="$style['package-table']">
            <th>
            <td>国标</td>
            <!-- <td>描述</td> -->
            </th>
            <tr>
              <td>{{currentLabProduct.examBasis.name}}</td>
              <!-- <td>{{currentLabProduct.examBasis.description}}</td> -->
            </tr>
          </table>
        </div>
      </pt-form-item>
      <pt-form-item label="检测依据相关文件：" :labelWidth="labelWidth" :lineHeight="lineHeight" :labelColor="labelColor">
        <a style="margin-right:20px;vertical-align:middle;" :href="$privateResourcesUrl+item.ossUrl" target="_blank" v-for="(item,i) in currentLabProduct.attachments" :key="i" :class="$style.special">{{item.name}}</a>
      </pt-form-item>
      <!-- <pt-form-item label="检测依据：" :labelWidth="labelWidth" :lineHeight="lineHeight" :labelColor="labelColor">
        <span>{{currentLabProduct.examBasis}}</span>
      </pt-form-item> -->
      <pt-form-item label="检测周期：" :labelWidth="labelWidth" :lineHeight="lineHeight" :labelColor="labelColor">
        <span>{{currentLabProduct.testCycle&&(currentLabProduct.testCycle + getdayType(currentLabProduct.dayType))}}</span>
      </pt-form-item>
      <pt-form-item label="创建时间：" :labelWidth="labelWidth" :lineHeight="lineHeight" :labelColor="labelColor">
        <span>{{formatDate(currentLabProduct.createdDate)}}</span>
      </pt-form-item>
    </div>
    <div class="marginTop">
      <el-button type="primary" @click="goEdit(currentLabProduct)">编辑</el-button>
      <el-button type="primary" plain @click="cancel">取消</el-button>

    </div>
  </div>
</template>

<script>
import { formatDate } from '@/utils/formUtils'
import {
  getdayType
} from 'enumeration/lab-order.js'
import orderFlow from '@/config/order'
// 组件class前缀
const prefixCls = 'pt-lab-product-detail'

export default {
  name: 'pt-lab-product-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    isUCAS () {
      return this.$store.state.saasConfig.tenant === 'ucas'
    }
  },
  props: {
    labProduct: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      currentLabProduct: this.labProduct,
      labelWidth: '180px',
      lineHeight: '26',
      labelColor: '#409eff',
      orderFlowHelper: orderFlow
    }
  },
  watch: {
    labProduct (val) {
      this.currentLabProduct = val
    }
  },
  methods: {
    formatDate,
    getdayType,
    goEdit (data) {
      this.$router.push(`/lab-product/lab-product-form/true/${data.id}`)
    },
    cancel () {
      history.go(-1)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

@import '~less/var.less';
.pt-lab-product-detail{
  color: #6D6D6D;
}
.special{
  color:@mainColor;
  text-decoration: none;
}
.package-table-div {
    margin-top: 10px;
    padding: 10px 20px 30px;
    max-width: 800px;
  }
  .package-table {
    display: table !important;
    width: 100%;
    border-collapse: collapse !important;
    th,
    tr {
      width: 100% !important;
      max-width: 100% !important;
      display: table-row;
      padding: 0 !important;
      list-style-type: none;
      border-bottom: 1px solid #c6c9d3;
      color: #818181;
    }
    td {
      text-align: center;
    }
  }
</style>
